module.exports = __webpack_public_path__ + "img/skyblueQunfa.be2f7423.png";